/* global jQuery, urchinTracker */
(function($/*, undefined*/) {
	// on load
	$(function() {

		var timer, currSlide = 0;

		function setSlide(i) {
			currSlide = i = i % 4;
			var id = "#TeamDesk";
			$("#prodmenu li").each(function(x, e) {
				if(x == i)
					id = $("a", e).attr("href");
				$(e).toggleClass("active", x == i);
			});
			$("#scrollcnt").stop();
			$("#scrollcnt").animate({
				left: -$(id).get(0).offsetLeft
			}, "slow");
			if(timer) clearTimeout(timer);
			timer = setTimeout(function() { setSlide(++currSlide); }, 5000);
		}

		var pa = $("#prodmenu a");
		if(pa.length) {
			pa.on("click", function(e) {
				var i = $(e.target).closest("li").index();
				setSlide(i);
				return false;
			});
			setSlide(0);
			$(window).on("orientationchange", function() { setSlide(0); });
		}
	});
})(jQuery);
